import React from 'react';

export function useIsAllProductSuggestionsPanelVisible(
    setMessagePositionToDisplayAllProductSuggestions: (value: number | undefined) => void
) {
    const [isVisible, setIsVisible] = React.useState(false);
    React.useEffect(() => {
        setIsVisible(true);
    }, []);
    const closeSuggestions = () => {
        setIsVisible(false);
        // We wait for the animation to finish before resetting the message position
        setTimeout(() => {
            setMessagePositionToDisplayAllProductSuggestions(undefined);
        }, 400);
    };
    return { isVisible, closeSuggestions };
}